var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import Button from "../../ui/Buttons/Button";
/**
 * Practical ceiling for a `mailto:` URL. Clients and operating systems truncate
 * long ones silently, and a half-delivered report is worse than none, so past
 * this the body carries a placeholder and the full text goes by clipboard.
 */
var MAILTO_LIMIT = 1800;
function buildMailto(email, subject, report) {
    // An empty recipient is a valid mailto: the client opens a compose window
    // with the To field blank, which is still better than no email at all.
    var to = email !== null && email !== void 0 ? email : "";
    var full = "mailto:".concat(to, "?subject=").concat(encodeURIComponent(subject), "&body=").concat(encodeURIComponent(report));
    if (full.length <= MAILTO_LIMIT)
        return full;
    var placeholder = "Paste the report here (it is already on your clipboard).\n\n";
    return "mailto:".concat(to, "?subject=").concat(encodeURIComponent(subject), "&body=").concat(encodeURIComponent(placeholder));
}
var CopyReportButton = function (_a) {
    var buildReport = _a.buildReport, subject = _a.subject, supportEmail = _a.supportEmail;
    var _b = useState("idle"), state = _b[0], setState = _b[1];
    var _c = useState(""), report = _c[0], setReport = _c[1];
    /** Always puts the report on the clipboard, whichever button was pressed. */
    var copyToClipboard = function (text) {
        setReport(text);
        var clipboard = navigator.clipboard;
        if (!(clipboard === null || clipboard === void 0 ? void 0 : clipboard.writeText)) {
            setState("manual");
            return;
        }
        clipboard.writeText(text).then(function () { return setState("copied"); }, function () { return setState("manual"); });
    };
    var copy = function () { return copyToClipboard(buildReport()); };
    var openEmail = function () {
        var text = buildReport();
        // Copied as well as sent: if the body had to be dropped for length, the
        // tester still has the report ready to paste.
        copyToClipboard(text);
        window.location.href = buildMailto(supportEmail, subject, text);
    };
    return (_jsxs("div", __assign({ className: "player-diagnostics__report-block" }, { children: [_jsxs("p", __assign({ className: "player-diagnostics__report-intro" }, { children: [_jsx("strong", { children: "Something did not pass? Send us the details." }), " The report lists what each check did, the line measurements taken during the test, and which browser and player version you are on. That is what we need to reproduce the problem without guessing."] })), _jsxs("ol", __assign({ className: "player-diagnostics__report-steps" }, { children: [_jsx("li", { children: "Click the button below: the report is copied to your clipboard." }), _jsx("li", { children: supportEmail ? (_jsxs(_Fragment, { children: ["Open a new email to ", _jsx("strong", { children: supportEmail }), ", or let the second button below start it for you."] })) : ("Open a new email to us, or let the second button below start one with the report already in it.") }), _jsx("li", { children: "Paste it into the message body (Ctrl+V, or Cmd+V on a Mac) and send." })] })), _jsxs("div", __assign({ className: "player-diagnostics__report-actions" }, { children: [_jsx(Button, __assign({ size: "small", onClick: copy, "data-testid": "copy-report" }, { children: state === "copied" ? "Report copied, now paste it into an email" : "Copy report for support" })), _jsx(Button, __assign({ size: "small", type: "primary", onClick: openEmail, "data-testid": "email-report" }, { children: "Prepare the email" }))] })), state === "manual" && (_jsxs("div", __assign({ className: "player-diagnostics__report" }, { children: [_jsx("p", { children: "Copying automatically was blocked by the browser. Select the text below and copy it by hand." }), _jsx("textarea", { className: "player-diagnostics__report-text", readOnly: true, value: report, rows: 10, "data-testid": "report-fallback" })] })))] })));
};
export default CopyReportButton;
